import {
  useEffect,
  useState
} from "react";

import {
  getLatestAnnouncements
} from "../services/announcementService";


const useAnnouncements = ({
  categorySlug = "ogloszenia",
  limit = 12
} = {}) => {
  const [announcements, setAnnouncements] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [error, setError] =
    useState(null);

  useEffect(() => {
    const controller = new AbortController();

    const loadAnnouncements = async () => {
      try {
        setLoading(true);
        setError(null);

        const data = await getLatestAnnouncements({
          categorySlug,
          limit,
          signal: controller.signal
        });

        setAnnouncements(data);
      } catch (error) {
        if (error.name !== "AbortError") {
          setError(error);
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };

    loadAnnouncements();

    return () => {
      controller.abort();
    };
  }, [
    categorySlug,
    limit
  ]);

  return {
    announcements,
    loading,
    error
  };
};


export default useAnnouncements;



